<template>
    <div name="preview" style="position: relative;" id="preview" class="preview">
        <home 
            v-if="nav === 0"
            @goBooking="goBooking"
            @goInbody="goInbody"
            @goSearchTab="navigationClick(1)"
            @resetCount="resetTimeoutCount"
            @goPayment="goPayment"
            @goFamily="goFamily"
            @goConcierge="goConcierge"
        />
        <search
            v-if="nav === 1"
            @goBookingTab="goBooking(1)"
            @goHomeTab="navigationClick(0)"
            @goListTab="goBooking(0)"
            @resetCount="resetTimeoutCount"
        />
        <challenge 
            v-if="nav === 2"
        />
        <booking 
            v-if="nav === 5"
            @goHistory="navigationClick(3)"
            @goHome="navigationClick(0)"
            :outStep="outBookingStep"
            @resetCount="resetTimeoutCount"
        />
        <history 
            v-if="nav === 3"
            @goDetail="goDetail"
            @goBooking="goBooking(1)"
            @resetCount="resetTimeoutCount"
        />
        <detail 
            v-if="nav === 6"
            :hospital="selectedHospital"
            :selectedTab="selectedTab"
            @goHistory="navigationClick(3)"
            @resetCount="resetTimeoutCount"
        />
        <my
            v-if="nav === 4" 
            @goHistory="nav = 3"
            @goHistoryHospital="navigationClick(3)"
            @resetCount="resetTimeoutCount"
            :selectedStep="selectedTab"
        />
        <concierge v-if="nav === 7" 
            @goHome="navigationClick(0)"
        />

        <navigation 
            v-if="nav !== 7"
            @onClick="navigationClick"
        />
        <div class="footer-button-div">
            <button class="button1" :style="{ background: brandColor, borderRight: '2px solid var(--xi-gray-3, #8F9499)' }" @click="gohome">홈 화면으로<br>돌아가기</button>
            <button class="button1" :style="{ background: brandColor, borderRight: '2px solid var(--xi-gray-3, #8F9499)' }" @click="goAi">AI<br>복약지도</button>
            <button class="button1" :style="{ background: brandColor }" @click="goConcierge">입주민 전용<br>컨시어지 서비스</button>
        </div>
        
    </div>
</template>

<script>
import Home from '@/components/showcase/Home';
import Navigation from '@/components/showcase/Navigation';
import Challenge from '@/components/showcase/Challenge';
import Search from '@/components/showcase/Search';
import Booking from '@/components/showcase/Booking';
import History from '@/components/showcase//History';
import Detail from '@/components/showcase/Detail';
import My from '@/components/showcase/My';
import Concierge from '@/components/showcase/Concierge';

// 솔닥 화면 및 플로팅버튼
export default {
  components: { Home, Navigation, Challenge, Search, Booking, History, Detail, My, Concierge},
    name: 'preview',
    data: function()
    {
        return {
            timerId: null,
            nav: 0,
            selectedHospital: 0,
            selectedTab: 0,
            outBookingStep: null
        }
    },
    computed: {
        basePath: function() {
            return '/' + this.$route.params.showcase
        },
        brandColor: function() {
            const showcase = this.$route.params.showcase;
            const colors = {
                xi: '#173C55',
                kocom: '#004EA2'
            };
            return colors[showcase] || '#173C55';
        }
    },
    mounted: function()
    {
        //진입시 home으로 이동 카운트 
        this.resetTimeoutCount();

        if(this.$route.query.step !== '' && this.$route.query.step !== null && this.$route.query.step !== undefined && this.$route.query.nav !== '' && this.$route.query.nav !== null && this.$route.query.step !== undefined)
        {
            this.selectedTab = Number(this.$route.query.step);
            this.nav = Number(this.$route.query.nav);

            const url = window.location.origin + window.location.pathname;
            window.history.replaceState({}, '', url);
        }
       
    },
    methods: {
        goPayment: function()
        {
            this.resetTimeoutCount();
            this.selectedTab = 6;
            this.nav = 4;
        },
        goFamily: function()
        {           
            this.resetTimeoutCount();
            this.selectedTab = 2;
            this.nav = 4;
        },
        resetTimeoutCount: function () {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(this.gohome, 50000);
        },
        clearTimer: function()
        {
            clearTimeout(this.timeoutId);
            this.timerId = null;
        },
        gohome: function() {
            this.clearTimer();
            window.location.href  = this.basePath + '/home'
        },
        navigationClick: function(nav)
        {
            this.selectedTab = 0;
            this.resetTimeoutCount();
            this.nav = nav;
        },
        goBooking: function(outstep)
        {
            this.resetTimeoutCount();
            if(outstep !== undefined)
            {
                this.outBookingStep = outstep
            }
            else
            {
                this.outBookingStep = null
            }

            this.nav = 5;
        },
        goDetail: function(hospital)
        {
            this.resetTimeoutCount();
            this.selectedHospital = hospital
            this.selectedTab = 0;
            this.nav = 6;   
        },
        goConcierge: function()
        {
            this.resetTimeoutCount();
            this.nav = 7;
        },
        goAi: function()
        {
            this.clearTimer();
            window.location.href  = this.basePath + '/preview?nav=6&step=3'
        },
        goInbody: function()
        {
            this.resetTimeoutCount();
            this.nav = 2;
        }
    }
}
</script>

<style scoped>
    .image {
        width: 100%;
        position: relative;
    }
    .button1 {
        width: 100%;
        height: 100%;
        background: var(--xi-dark-blue, #173C55);
        z-index: 999;
        color: var(--xi-gray-0, #FFF);
        font-family: Pretendard;
        font-size: clamp(14px, 3.3vw, 56px);
        font-style: normal;
        font-weight: 500;
        line-height: 126.494%;
        border: none;
    }
    .footer-button-div {
        display: flex;
        width: 100%;
        aspect-ratio: 375/60;
        justify-content: flex-start;
        align-items: center;
        position: fixed;
        bottom: 0;
        left: 0;
    }
    .preview {
        width: 100%;
        box-sizing: border-box;
        padding: 0 4vw;
        background: #F0F1F4;
    }
</style>


// WEBPACK FOOTER //
// src/page/showcase/Preview.vue